// Authorization header for backend calls: routes that spend money (LLM,
// vision, transcription) only answer requests carrying a valid session JWT.
export default function authHeaders(extra = {}) {
  let token = null;
  try { token = localStorage.getItem('token'); } catch { /* storage unavailable */ }
  return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
}
